import React from 'react';
import { AnimatedSection } from './AnimatedSection';
export function PainSection() {
  return <section className="w-full px-6 py-16 md:py-20" data-id="element-215">
      <div className="max-w-2xl mx-auto" data-id="element-216">
        <AnimatedSection data-id="element-217">
          <div className="w-12 h-px bg-sand mx-auto mb-12" data-id="element-218" />
        </AnimatedSection>

        <AnimatedSection data-id="element-219">
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal leading-tight mb-10" data-id="element-220">
            Si esto te pasa, no estás sola
            <span className="text-teal" data-id="element-221">.</span>
            <br data-id="element-222" />
            <span className="text-warm-gray text-2xl md:text-3xl" data-id="element-223">
              Pero sí estás cargando demasiado.
            </span>
          </h2>
        </AnimatedSection>

        <AnimatedSection delay={0.1} data-id="element-224">
          <div className="space-y-5 text-charcoal/80 text-base md:text-lg leading-relaxed" data-id="element-225">
            <p data-id="element-226">Si tu casa está desbordada, no es porque no sepas limpiar.</p>
            <p className="font-medium text-charcoal" data-id="element-227">
              Es porque la vida no te está dejando sostenerlo.
            </p>
            <p data-id="element-228">Y cuando la casa se cae, tú te culpas.</p>
            <p className="text-charcoal/60 italic" data-id="element-229">
              Como si el caos fuera un defecto moral.
            </p>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.15} data-id="element-230">
          <div className="mt-10 mb-10" data-id="element-231">
            <p className="text-charcoal/90 text-base md:text-lg leading-relaxed mb-4" data-id="element-232">
              Pero mira la realidad:
            </p>
            <ul className="space-y-3" data-id="element-233">
              <li className="flex items-start gap-3 text-charcoal/80 text-base md:text-lg leading-relaxed" data-id="element-234">
                <span className="w-1.5 h-1.5 rounded-full bg-teal mt-2.5 flex-shrink-0" aria-hidden="true" data-id="element-235" />
                <span data-id="element-236">
                  Cuando estás saturada, tu cerebro busca{' '}
                  <strong className="text-charcoal font-medium" data-id="element-237">
                    evitar decisiones
                  </strong>
                  .
                </span>
              </li>
              <li className="flex items-start gap-3 text-charcoal/80 text-base md:text-lg leading-relaxed" data-id="element-238">
                <span className="w-1.5 h-1.5 rounded-full bg-teal mt-2.5 flex-shrink-0" aria-hidden="true" data-id="element-239" />
                <span data-id="element-240">
                  Y limpiar, en una casa caótica, es{' '}
                  <strong className="text-charcoal font-medium" data-id="element-241">
                    pura decisión
                  </strong>
                  : ¿esto dónde va?, ¿qué hago primero?, ¿qué tiro?, ¿qué
                  guardo?
                </span>
              </li>
            </ul>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.2} data-id="element-242">
          <p className="font-serif text-xl md:text-2xl text-charcoal leading-snug" data-id="element-243">
            Por eso te congelas.
          </p>
          <p className="text-teal font-medium text-lg mt-3" data-id="element-244">
            No por floja. Por sobrecarga.
          </p>
        </AnimatedSection>
      </div>
    </section>;
}